import {
  ContentFragment,
  NAV_CONTENT,
  NAV_CONTENT_FAILED,
  NAV_CONTENT_SUCCESS,
  MEDICAL_QUESTIONNAIRE,
  MEDICAL_QUESTIONNAIRE_FAILED,
  MEDICAL_QUESTIONNAIRE_SUCCESS,
  NEED_ANALYSIS_QUESTIONNAIRE,
  NEED_ANALYSIS_QUESTIONNAIRE_FAILED,
  NEED_ANALYSIS_QUESTIONNAIRE_SUCCESS,
  MQContent
} from './types';
import { filter, find, get, omit } from 'lodash';
import { CONTACT_US_KEY } from '@trip-ux/constants';

export const contentFragment = (
  state: ContentFragment = {
    navContentFetched: false,
    contactUsFetched: false
  },
  action: {
    type: string;
    payload?: unknown;
  }
): ContentFragment => {
  switch (action.type) {
    case NAV_CONTENT:
      return { ...state, navContentFetched: false, contactUsFetched: false };
    case NAV_CONTENT_SUCCESS:
      return {
        ...state,
        ...mapOrgResponse(action.payload)
      };
    case NAV_CONTENT_FAILED:
      return {
        ...state,
        navContentFetched: true,
        navContentError: action.payload
      };
    case MEDICAL_QUESTIONNAIRE:
      return {
        ...state,
        medicalQuestionnaireFetched: false
      };
    case MEDICAL_QUESTIONNAIRE_SUCCESS:
      return mapMQResponse(state, action);
    case MEDICAL_QUESTIONNAIRE_FAILED:
      return {
        ...state,
        medicalQuestionnaireFetched: true,
        medicalQuestionnaireError: action.payload
      };
    case NEED_ANALYSIS_QUESTIONNAIRE:
      return {
        ...state,
        needAnalysisQuestionnaireFetched: false
      };
    case NEED_ANALYSIS_QUESTIONNAIRE_SUCCESS:
      const payload = action.payload as MQContent;
      const existingNA = filter(state.needAnalysisQuestionnaire, mq => mq.planClass !== payload.planClass);
      return {
        ...state,
        needAnalysisQuestionnaireFetched: true,
        needAnalysisQuestionnaire: [...existingNA, payload]
      };
    case NEED_ANALYSIS_QUESTIONNAIRE_FAILED:
      return {
        ...state,
        needAnalysisQuestionnaireFetched: true,
        needAnalysisQuestionnaireError: action.payload
      };
    default:
      return state;
  }
};

const mapMQResponse = (state, action) => {
  const payload = action.payload as MQContent;
  const organization = get(payload, 'organization');
  const planClass = get(payload, 'planClass');
  const mq = omit(payload, 'organization');

  const existingMQ = filter(state.medicalQuestionnaire, mqItem => mqItem.planClass !== planClass);
  return {
    ...state,
    medicalQuestionnaireFetched: true,
    medicalQuestionnaire: [...existingMQ, mq],
    mqNotEligible: get(organization, 'contract.content.mqNotEligible'),
    mqLIAScripting: get(organization, 'contract.content.mqLIAScripting')
  };
};

export const mapOrgResponse = (data): ContentFragment => {
  const { organization } = data;
  return {
    banner: get(organization, 'contract.content.banner'),
    contactUs: find(get(organization, 'contacts', []), { contactType: CONTACT_US_KEY }),
    contactUsFetched: true,
    contentRoot: get(organization, 'contract.contentRoot'),
    footer: get(organization, 'contract.content.footer'),
    navContentFetched: true,
    organizationCode: get(organization, 'code'),
    organizationName: get(organization, 'organizationName'),
    organizationNameInFrench: get(organization, 'organizationNameInFrench'),
    sideNav: get(organization, 'contract.content.sideNav'),
    topNav: get(organization, 'contract.content.topNav'),
    whiteLabelRoot: get(organization, 'contract.whiteLabelRoot'),
    acm: get(organization, 'contract.content.acm'),
    needAssistance: get(organization, 'contract.content.needAssistance'),
    qpi: get(organization, 'contract.content.qpi'),
    termsAndConditions: get(organization, 'contract.content.termsAndConditions'),
    bill96Consent: get(organization, 'contract.content.bill96Consent')
  };
};
